import React from "react";

const ChooseSubscriptionIcon = (props: any) => (
  <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 11.557h5.556M11 11.557V6"
      stroke="#FFFCF4"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <circle cx={11} cy={11} r={10} stroke="#FFFCF4" strokeWidth={2} />
  </svg>
);

export default ChooseSubscriptionIcon;
